{
  "name": "lautec-analytics",
  "version": "2.2.0",
  "scripts": {
    "preinstall": "node .claude/scripts/validate-toolchain.mjs",
    "validate:toolchain": "node .claude/scripts/validate-toolchain.mjs",
    "validate:agentic-engineering": "node .claude/scripts/validate-agentic-engineering.mjs",
    "test:agentic-engineering": "bun test ./.claude/scripts/tests/validate-agentic-engineering.test.js",
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build-test": "ng build --configuration testing",
    "build-prod": "ng build --configuration production",
    "build-demo": "ng build --configuration demo",
    "preview": "vite preview",
    "test": "ng test",
    "test:ci": "ng test",
    "test:coverage": "ng test --configuration coverage",
    "lint": "ng lint --max-warnings=0",
    "release": "semantic-release --branches \"$RELEASE_BRANCH\" && git push origin HEAD --tags",
    "release-patch": "semantic-release --extends \"$SR_BRANCH_CONFIG_PATH\" && git push origin HEAD --tags",
    "release:dry": "semantic-release --dry-run --branches \"$RELEASE_BRANCH\"",
    "release-patch:dry": "semantic-release --dry-run --extends \"$SR_BRANCH_CONFIG_PATH\"",
    "format:write": "prettier \"src/**/*.{ts,json,scss,html}\" --write",
    "format:check": "prettier \"src/**/*.{ts,json,scss,html}\" --check",
    "format:check:changed": "node .claude/scripts/format-check-changed.mjs",
    "docs:lint": "markdownlint-cli2 --config .claude/markdownlint-cli2.jsonc \"**/*.md\"",
    "validate:docs": "node .claude/scripts/validate-docs.mjs",
    "test:docs-governance": "bun test ./.claude/scripts/tests/validate-docs-governance.test.js",
    "test:format-check-changed": "bun test ./.claude/scripts/tests/format-check-changed.test.js",
    "validate:golden-principles": "node .claude/scripts/validate-golden-principles.mjs",
    "test:golden-principles": "bun test ./.claude/scripts/tests/validate-golden-principles.test.js",
    "validate:golden-principles-review": "node .claude/scripts/validate-golden-principles-review.mjs",
    "test:golden-principles-review": "bun test ./.claude/scripts/tests/validate-golden-principles-review.test.js",
    "validate:test-impact-map": "node .claude/scripts/select-angular-tests.mjs --validate",
    "test:test-impact-selector": "bun test ./.claude/scripts/tests/select-angular-tests.test.js",
    "test:affected:paths": "node .claude/scripts/select-angular-tests.mjs --source explicit --require-mapped --execute",
    "test:affected:worktree": "node .claude/scripts/select-angular-tests.mjs --source worktree --require-mapped --execute",
    "test:affected:staged": "node .claude/scripts/select-angular-tests.mjs --source staged --require-mapped --execute",
    "test:affected:branch": "node .claude/scripts/select-angular-tests.mjs --source branch --base origin/master --require-mapped --execute",
    "test:context-statusline": "powershell.exe -NoProfile -ExecutionPolicy Bypass -File .claude/scripts/tests/context-statusline.regression.ps1",
    "test:context-checkpoint": "powershell.exe -NoProfile -ExecutionPolicy Bypass -File .claude/scripts/tests/context-checkpoint.regression.ps1",
    "test:bitbucket-pr": "node .claude/scripts/run-bitbucket-pr-tests.mjs",
    "test:changelog": "bun test ./pipelines/tests/changelog-generation.test.js",
    "test:governance": "bun run test:agentic-engineering && bun run test:docs-governance && bun run test:format-check-changed && bun run test:golden-principles && bun run test:golden-principles-review && bun run test:test-impact-selector && bun run test:context-statusline && bun run test:context-checkpoint && bun run test:bitbucket-pr",
    "prepare": "husky install"
  },
  "lint-staged": {
    "*.{ts,html}": [
      "eslint --max-warnings=0",
      "prettier --write"
    ],
    "*.{json,scss}": [
      "prettier --write"
    ],
    "**.md": "bun run validate:docs",
    "{CLAUDE.md,AGENTS.md,package.json,angular.json,.node-version,.mcp.json,openspec/config.yaml,.claude/scripts/validate-agentic-engineering.mjs,.claude/scripts/validate-toolchain.mjs,.claude/scripts/tests/validate-agentic-engineering.test.js,pipelines/*.yaml}": "bun run validate:agentic-engineering",
    "{CLAUDE.md,AGENTS.md,package.json,.claude/governance/**,.claude/schemas/golden-principles-review.schema.json,.claude/rules/golden-principles.md,.claude/skills/golden-principles-maintenance/**,.claude/scripts/validate-golden-principles*.mjs,.claude/scripts/lib/changed-files.mjs,.claude/scripts/lib/review-snapshot.mjs,.claude/scripts/tests/validate-golden-principles*.test.js,pipelines/azure-pipelines-testing-ci.yaml,pipelines/azure-pipelines-testing-pr.yaml}": "bun run validate:golden-principles-review -- --source staged",
    "src/app/**/*.ts": [
      "bun run validate:golden-principles",
      "bun run test:affected:staged"
    ],
    "{.claude/commands/pr.md,.claude/rules/bitbucket-integration.md,.claude/scripts/bitbucket-pr.ps1,.claude/scripts/bitbucket-comment.ps1,.claude/scripts/run-bitbucket-pr-tests.mjs,.claude/scripts/lib/powershell.mjs,.claude/scripts/tests/bitbucket-pr.tests.ps1}": [
      "bun run test:bitbucket-pr"
    ]
  },
  "commitlint": {
    "extends": [
      "@commitlint/config-conventional"
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.2",
    "@angular/cdk": "^20.2.13",
    "@angular/common": "^20.3.2",
    "@angular/compiler": "^20.3.2",
    "@angular/core": "^20.3.2",
    "@angular/forms": "^20.3.2",
    "@angular/material": "^20.2.13",
    "@angular/platform-browser": "^20.3.2",
    "@angular/platform-browser-dynamic": "^20.3.2",
    "@angular/router": "^20.3.2",
    "@azure/msal-angular": "^4.0.20",
    "@azure/msal-browser": "^4.24.0",
    "@microsoft/applicationinsights-web": "^3.3.10",
    "@ngrx/component": "^20.0.1",
    "@ngrx/effects": "^20.0.1",
    "@ngrx/operators": "^20.0.1",
    "@ngrx/signals": "^20.1.0",
    "@ngrx/store": "^20.0.1",
    "@ngrx/store-devtools": "^20.0.1",
    "bootstrap": "^5.3.8",
    "dayjs": "^1.11.18",
    "ngx-toastr": "19.1.0",
    "powerbi-client": "^2.23.7",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "20.3.0",
    "@angular/build": "^20.3.3",
    "@angular/cli": "^20.3.3",
    "@angular/compiler-cli": "^20.3.2",
    "@angular/language-service": "^20.3.2",
    "@commitlint/cli": "^19.8.1",
    "@commitlint/config-conventional": "^19.8.1",
    "@eslint/compat": "^1.4.0",
    "@eslint/eslintrc": "^3.3.1",
    "@eslint/js": "^9.36.0",
    "@semantic-release/changelog": "6.0.3",
    "@semantic-release/commit-analyzer": "13.0.1",
    "@semantic-release/git": "10.0.1",
    "@semantic-release/npm": "13.1.5",
    "@semantic-release/release-notes-generator": "14.1.1",
    "@types/bootstrap": "^5.2.10",
    "@types/node": "^24.5.2",
    "@typescript-eslint/types": "8.44.1",
    "@vitest/coverage-v8": "3.2.7",
    "ajv": "~8.17.1",
    "ajv-formats": "~3.0.1",
    "angular-eslint": "^20.3.0",
    "baseline-browser-mapping": "^2.9.18",
    "conventional-changelog-conventionalcommits": "9.3.1",
    "eslint": "^9.36.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-import-resolver-typescript": "^4.4.4",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-prettier": "^5.5.4",
    "eslint-plugin-rxjs-x": "^0.7.7",
    "eslint-plugin-unused-imports": "^4.2.0",
    "husky": "^9.1.7",
    "jsdom": "30.0.1",
    "lint-staged": "^17.3.0",
    "markdownlint-cli2": "^0.23.2",
    "prettier": "^3.6.2",
    "prettier-eslint": "^16.4.2",
    "sass": "^1.93.2",
    "semantic-release": "25.0.8",
    "ts-node": "^10.9.2",
    "typescript": "~5.9.2",
    "typescript-eslint": "^8.44.1",
    "vitest": "3.2.7"
  },
  "engines": {
    "node": "24.14.0",
    "bun": "1.3.1"
  },
  "packageManager": "bun@1.3.1"
}
